import * as React from "react"
import { cn } from "../../lib/utils"

export interface LogoProps extends React.SVGProps<SVGSVGElement> {
  className?: string
  background?: string
}

export const Logo = React.forwardRef<SVGSVGElement, LogoProps>(
  ({ className, background, style, ...props }, ref) => {
    const svgElement = (
      <svg
        ref={ref}
        className={cn("w-20 h-5", className)}
        viewBox="0 0 75 20"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
        {...props}
      >
        <path
          d="M32.6875 15.1408V5.10327H36.2668C39.2216 5.10327 41.2809 7.13982 41.2809 10.0646C41.2809 12.9893 39.2216 15.1408 36.2668 15.1408H32.6875ZM34.392 13.5919H36.3807C38.2267 13.5919 39.52 12.1434 39.52 10.0646C39.52 8.10061 38.2279 6.65216 36.3807 6.65216H34.392V13.5919Z"
          fill="currentColor"
        />
        <path
          d="M41.4375 11.3689C41.4375 8.85919 43.0713 7.3103 45.1738 7.3103C47.2763 7.3103 48.7243 8.81563 48.7675 11.2817V11.6835H43.1145C43.2283 13.017 44.0518 13.9209 45.3309 13.9209C46.1975 13.9209 46.8508 13.4901 47.1061 12.7302H48.7399C48.3564 14.365 47.0917 15.3548 45.3165 15.3548C43.015 15.3548 41.4387 13.691 41.4387 11.3689H41.4375ZM47.0342 10.494C46.8208 9.40372 46.1532 8.74423 45.1738 8.74423C44.1945 8.74423 43.4405 9.40372 43.1852 10.494H47.0342Z"
          fill="currentColor"
        />
        <path
          d="M48.9785 11.283C48.9785 8.78781 50.6399 7.31152 52.8275 7.31152C54.8869 7.31152 56.2797 8.58815 56.4212 10.4807H54.773C54.6172 9.43398 53.8788 8.75997 52.8131 8.75997C51.5341 8.75997 50.6819 9.73529 50.6819 11.2842C50.6819 12.948 51.6192 13.9088 52.8695 13.9088C53.892 13.9088 54.6028 13.2493 54.773 12.1591H56.4212C56.2222 14.123 54.8725 15.3561 52.8707 15.3561C50.4134 15.3561 48.9785 13.5785 48.9785 11.2842V11.283Z"
          fill="currentColor"
        />
        <path
          d="M56.4941 5.41791C56.4941 4.80077 56.9628 4.32764 57.5742 4.32764C58.1855 4.32764 58.6542 4.80077 58.6542 5.41791C58.6542 6.03504 58.1999 6.52149 57.5742 6.52149C56.9484 6.52149 56.4941 6.03383 56.4941 5.41791ZM56.7363 15.1408V7.54158H58.412V15.1408H56.7363Z"
          fill="currentColor"
        />
        <path
          d="M58.7852 11.2974C58.7852 8.94625 60.22 7.31145 62.223 7.31145C63.2886 7.31145 64.1685 7.75555 64.6947 8.47312V4.38672H66.3705V15.1418H65.0208L64.8649 13.7938C64.4394 14.7546 63.5008 15.3572 62.2793 15.3572C60.2476 15.3572 58.7852 13.6934 58.7852 11.2986V11.2974ZM64.6947 11.2829C64.6947 9.77757 63.8424 8.73086 62.621 8.73086C61.3995 8.73086 60.5041 9.79209 60.5041 11.3119C60.5041 12.8318 61.3564 13.9221 62.5922 13.9221C63.8281 13.9221 64.6947 12.8318 64.6947 11.2841V11.2829Z"
          fill="currentColor"
        />
        <path
          d="M67.1289 15.1402V7.54099H68.4786L68.6776 9.0318C69.1607 7.99961 70.0417 7.45508 71.2908 7.45508H71.5749V9.1044H71.2908C69.7289 9.1044 68.8047 9.95024 68.8047 11.3842V15.1414H67.1289V15.1402Z"
          fill="currentColor"
        />
        <path
          d="M15.4006 14.9966L13.0788 11.5322H7.2615C6.0724 11.5322 5.10386 10.5557 5.10386 9.35408V7.2776C5.10386 6.07721 6.0712 5.09948 7.2615 5.09948H8.76706L6.45598 1.65199L1.54134 1.63989C1.51377 1.63989 1.4898 1.64957 1.46942 1.67014C1.44904 1.69072 1.43945 1.71492 1.43945 1.74396V14.8938C1.43945 14.9506 1.485 14.9966 1.54134 14.9966H15.4006Z"
          fill="currentColor"
        />
        <path
          d="M20.4646 18.4545C24.1134 18.4545 27.0814 15.4571 27.0814 11.7737C27.0814 8.09024 24.1134 5.09412 20.4646 5.09412L8.77734 5.10985L11.0896 8.55854H20.4646C22.2207 8.55854 23.6507 10.0009 23.6507 11.7749C23.6507 13.5489 22.2219 14.9913 20.4646 14.9913H15.4001L17.722 18.4557H20.4646V18.4545Z"
          fill="currentColor"
        />
      </svg>
    )

    // If background is provided, wrap in a div with the background
    if (background) {
      return (
        <div 
          className="inline-flex items-center justify-center rounded-lg p-2"
          style={{ background }}
        >
          {svgElement}
        </div>
      )
    }

    return svgElement
  }
)
Logo.displayName = "Logo" 